import generic from './generic'

const getDefaultState = () => {
  return {
    all: [],
    details: [],
    errored: false,
    loading: false,
    fetchedAt: null,
  }
}

const state = getDefaultState()

const mutations = {
  ...generic.mutations,
  'RESET': function (state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  ...generic.actions,
  getAll (context) {
    return generic.getAll(context, {url: '/alliance/page/'})
  },
  backgroundRefresh (context) {
    return generic.getAll(context, {url: '/alliance/page/', hideLoading: true})
  },
}

const getters = {
  ...generic.getters,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
